(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function lock(on) { document.documentElement.classList.toggle('dasii-lock', on); }

  /* ---------- email popup ---------- */
  function initPopup() {
    var KEY = 'dasii_popup_seen';
    var p = document.getElementById('DasiiPopup');
    if (!p) return;
    function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    function mark() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function open() {
      var el = document.getElementById('DasiiPopup'); if (!el) return;
      el.hidden = false; lock(true);
      var f = el.querySelector('input[type=email]') || el.querySelector('.dasii-pop__close');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }
    function close() {
      var el = document.getElementById('DasiiPopup'); if (el) el.hidden = true;
      lock(false); mark();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#DasiiPopup [data-dasii-close]')) close();
      else if (e.target && e.target.id === 'DasiiPopup') close();
    });
    document.addEventListener('keydown', function (e) {
      var el = document.getElementById('DasiiPopup');
      if (e.key === 'Escape' && el && !el.hidden) close();
    });
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'DasiiPopForm') mark();
    });
    if (location.hash === '#DasiiPopForm' && p.querySelector('.dasii-pop__ok, .dasii-pop__err')) { open(); return; }
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        var el = document.getElementById('DasiiPopup');
        if (el && e.detail && e.detail.sectionId === el.dataset.sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', function () {
        var el = document.getElementById('DasiiPopup'); if (el) el.hidden = true; lock(false);
      });
      return;
    }
    if (!seen()) {
      var d = (parseInt(p.dataset.delay, 10) || 5) * 1000;
      setTimeout(function () { if (!seen()) open(); }, d);
    }
  }

  /* ---------- free shipping bar ---------- */
  function fmt(c, cur) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur || 'GBP', minimumFractionDigits: c % 100 === 0 ? 0 : 2 }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2); }
  }
  function paint(total) {
    var bars = document.querySelectorAll('[data-dasii-ship]');
    Array.prototype.forEach.call(bars, function (el) {
      var t = parseInt(el.dataset.threshold, 10) || 0;
      var cur = el.dataset.currency;
      var msg = el.querySelector('[data-dasii-ship-msg]');
      var fill = el.querySelector('[data-dasii-ship-fill]');
      var pct = t ? Math.min(100, Math.round(total / t * 100)) : 0;
      if (fill) fill.style.width = pct + '%';
      if (!msg) return;
      var text;
      if (total <= 0) text = (el.dataset.msgDefault || '').replace('[threshold]', fmt(t, cur));
      else if (total >= t) text = el.dataset.msgDone || '';
      else text = (el.dataset.msgAway || '').replace('[amount]', fmt(t - total, cur));
      msg.textContent = text;
    });
  }
  function refresh() {
    if (!document.querySelector('[data-dasii-ship]')) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.total_price || 0); })
      .catch(function () {});
  }
  function placeShipBar() {
    var bar = document.querySelector('[data-dasii-ship]');
    if (!bar) return;
    var form = document.querySelector('#MainContent form[action*="/cart/add"]');
    if (form) {
      var anchor = form.closest('buy-buttons-component, .buy-buttons-block, [class*="buy-buttons"]') || form;
      anchor.parentNode.insertBefore(bar, anchor.nextSibling);
    } else {
      bar.classList.add('dasii-ship--loose');
    }
  }
  function watchCart() {
    if (!window.fetch || window.__dasiiFetch) return;
    window.__dasiiFetch = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var pr = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) {
        pr.then(function () { setTimeout(refresh, 250); }).catch(function () {});
      }
      return pr;
    };
    document.addEventListener('cart:update', function () { setTimeout(refresh, 250); });
  }

  /* ---------- back to top ---------- */
  function backToTop() {
    var footer = document.querySelector('footer');
    if (!footer || document.querySelector('.dasii-btt')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dasii-btt'; b.textContent = 'BACK TO TOP';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    footer.parentNode.insertBefore(b, footer);
  }

  function init() { initPopup(); placeShipBar(); watchCart(); refresh(); backToTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
